export * from '../../../store';

export enum Fields {
  Module = 'assocation-registration',
  Orgs = 'orgs',
  PastOrgs = 'orgs',
  SelectedOrg = 'selected-org',
  SelectedPastOrg = 'selected-past-org',
  TeamsList = 'teams-list',
  SelectedTeam = 'selected-team',
  TeamPlayersStat = 'team-players-stat',
  TeamPlayersList = 'team-players-list',
  RegisteringPlayers = 'team-registering-players',
  RegisteringStaff = 'team-registering-staff',
  OrgsStats = 'orgs-stats',
  OrgsPastStats = 'orgs-past-stats'
}

export interface AssocationRegistrationState {
  [field: string]: any;
}

export const InitialState: AssocationRegistrationState = {
  [Fields.Orgs]: null,
  [Fields.PastOrgs]: null,
  [Fields.OrgsStats]: null,
  [Fields.OrgsPastStats]: null,
  [Fields.SelectedOrg]: null,
  [Fields.SelectedPastOrg]: null,
  [Fields.TeamsList]: null,
  [Fields.SelectedTeam]: null,
  [Fields.TeamPlayersStat]: null,
  [Fields.TeamPlayersList]: null,
  [Fields.RegisteringPlayers]: null,
  [Fields.RegisteringStaff]: null
};

export enum Types {
  UpdateState = 'update-assocation-state',
  GetOrgList = 'get-org-list',
  GetPastOrgList = 'get-past-org-list',
  GetOrgsStats = 'get-orgs-stats',
  GetOrgsPastStats = 'get-orgs-past-stats',
  GetTeamsList = 'get-teams-list',
  GetOrg = 'get-org',
  GetPastOrg = 'get-past-org',
  GetTeam = 'get-team',
  GetTeamPlayersStat = 'get-team-players-stat',
  GetTeamPlayersList = 'get-team-players-list'
}

export interface UpdateState { type: Types.UpdateState; payload: any; }
export interface GetOrgList { type: Types.GetOrgList; payload: { clubId: number }; }
export interface GetOrg { type: Types.GetOrgList; payload: { orgId: number, seasonId: number }; }
export interface GetPastOrg { type: Types.GetPastOrgList; payload: { orgSeasonId: number, clubId: number }; }
export interface GetOrgsStats { type: Types.GetOrgsStats; payload: { clubId: number }; }
export interface GetOrgsPastStats { type: Types.GetOrgsPastStats; payload: { clubId: number, orgSeasonId: number }; }
export interface GetTeamsList { type: Types.GetTeamsList; payload: { orgId: number; clubId: number; seasonId: number; status: number }; }
export interface GetTeam { type: Types.GetOrgList; payload: { orgId: number, clubId: number, seasonId: number, teamId: number }; }
export interface GetTeamPlayersStat { type: Types.GetTeamPlayersStat; payload: { orgId: number, divisionID: number, seasonId: number, teamId: number }; }
export interface GetTeamPlayersList { type: Types.GetTeamPlayersList; payload: { orgId: number, divisionID: number, seasonId: number, teamId: number, clubID: number, status: number }; }

export type ModuleAction = UpdateState;



// WEBPACK FOOTER //
// ./src/app/pages/association-registration/store/assocation-registration.models.ts